const appWidth = 1440;

const colors = {
    black: '#111111',
    blue: {
        100: '#E8F4F8',
        200: '#BDDCE9',
        300: '#8AD5E9',
        400: '#1DA3D0',
        500: '#4E79A7',
        600: '#00aad2'
    },
    green: {
        500: '#77B800',
    },
    grey: {
        100: '#F2F2F2',
        200: '#F1F2F2',
        300: '#878787',
        500: '#252828',
    },
    orange: {
        400: '#FF7900',
        500: '#F28E2B'
    },
    red: {
        100: '#E1B3B5',
        500: '#D40072',
        600: '#BE0000',
    },
    link: '#0081AB'
};

module.exports = {
    purge: [
        './src/**/*.vue',
        './src/**/*.ts',
    ],
    theme: {
        screens: {
            mobile: { max: '639px' },
            sm: '640px',
            md: '768px',
            lg: '1024px',
            xl: '1280px',
            '2xl': '1440px'
        },
        extend: {
            opacity: {
                4: '0.04'
            },
            backgroundColor: { ...colors },
            borderColor: { ...colors },
            colors: {
                ...colors,
                header: {
                    title: colors.blue[600],
                    link: colors.blue[600],
                },
                'map-legend': {
                    background: colors.grey[100],
                },
                map: {
                    'contaminated-site-upstream': colors.red[500],
                    reclamation: colors.green[500],
                    'petroleum-storage-tank': colors.orange[500],
                    'site-contamination-and-decomissioning': colors.blue[500],
                },
                search: {
                    icon: colors.grey[100],
                },
                report: {
                    'circle-yes': '#AA0006',
                    'circle-no': '#BBC0C0',
                }
            },
            fontFamily: {
                helvetica: ['Helvetica', 'Arial', 'sans-serif'],
                'helvetica-nueue': ['Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'],
                'acumin-pro-semi-condensed': ['acumin-pro-semi-condensed', 'cursive']
            },
            height: {
                'detail-image': '350px',
                'detail-circle-image': '130px',
            },
            maxWidth: {
                app: `${appWidth}px`
            },
            width: {
                'left-panel': '500px',
                'right-panel': '500px',
                legend: '470px',
                'detail-image': '400px',
                'detail-circle-image': '130px',
            }
        },
    },
    variants: {},
    plugins: [],
};
